import { SFCancelOrderModal, SFWithoutSuggestionsModal } from './components';

export function SubstitutionFlowModalCenterContainer() {
  return (
    <>
      <SFWithoutSuggestionsModal />
      <SFCancelOrderModal />
    </>
  );
}
